import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import styled from 'styled-components';
import { BouRadioButtonWithLabel } from '../../../../generic/components/inputs/bou-radio-button-with-label';
import { getTextStyle } from '../../../../generic/content/texts/bou-text/text-style';
import { friendlyScoreUnit } from '@upright/common/utils';

interface Props {
  scoreType: FinalImpactScoreType;
  setScoreType: (mode: FinalImpactScoreType) => void;
  absoluteDisabled: boolean;
  isAbsoluteScoreTypesHidden: boolean;
  className?: string;
  enableE2eTestIds: true | undefined;
}

export function ScoreTypeRadioSelector(props: Props) {
  const { scoreType } = props;
  return (
    <Root className={props.className}>
      <Button
        label={friendlyScoreUnit(FinalImpactScoreType.CENTS_PER_DOLLAR)}
        checked={scoreType === FinalImpactScoreType.CENTS_PER_DOLLAR}
        onSelect={() => {
          props.setScoreType(FinalImpactScoreType.CENTS_PER_DOLLAR);
        }}
      />
      {!props.isAbsoluteScoreTypesHidden && (
        <Button
          label={friendlyScoreUnit(FinalImpactScoreType.DOLLARS_PER_YEAR)}
          checked={scoreType === FinalImpactScoreType.DOLLARS_PER_YEAR}
          disabled={props.absoluteDisabled}
          onSelect={() => {
            props.setScoreType(FinalImpactScoreType.DOLLARS_PER_YEAR);
          }}
        />
      )}
      <Button
        label={friendlyScoreUnit(FinalImpactScoreType.RELATIVE)}
        id={props.enableE2eTestIds && E2eTestElementId.REL_TOGGLE}
        checked={scoreType === FinalImpactScoreType.RELATIVE}
        onSelect={() => {
          props.setScoreType(FinalImpactScoreType.RELATIVE);
        }}
      />
      {!props.isAbsoluteScoreTypesHidden && (
        <Button
          label={friendlyScoreUnit(FinalImpactScoreType.ABSOLUTE)}
          id={props.enableE2eTestIds && E2eTestElementId.ABS_TOGGLE}
          checked={scoreType === FinalImpactScoreType.ABSOLUTE}
          disabled={props.absoluteDisabled}
          onSelect={() => {
            props.setScoreType(FinalImpactScoreType.ABSOLUTE);
          }}
        />
      )}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  ${getTextStyle({ size: 'xxxs' })};
`;

const Button = styled(BouRadioButtonWithLabel)`
  & + & {
    margin-left: 1.3em;
  }
`;
